<template>
  <div>
    <Form inline :label-width="100">
        <FormItem label="开始时间">
          <DatePicker type="date" placeholder="请选择开始时间" style="width: 200px" v-model="params.start_date" @on-change="params.start_date = $event"></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
          <DatePicker type="date" placeholder="请选择结束时间" style="width: 200px" v-model="params.end_date" @on-change="params.end_date = $event"></DatePicker>
        </FormItem>
        <FormItem label="统计类型">
          <Select v-model="params.type">
            <Option value="week" key="week">按周统计</Option>
            <Option value="month" key="month">按月统计</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <Button type="primary" icon="ios-search" @click="query">统计</Button>
        </FormItem>
    </Form>
    <Table border :columns="columns" :data="result" :loading="loading" ref="table"></Table>
    <Button type="primary" size="large" @click="exportData()" style="margin-top: 10px;"><Icon type="ios-download-outline"></Icon>导出统计结果</Button>
  </div>

</template>

<script>
import { Statistics } from '@/services/resources'
import dict from '@/mixins/dict'

export default {
  mixins: [dict],
  name: 'PmpRecordEvaluate',
  components: {
  },
  data () {
    return {
      params: {},
      result: [],
      columns: [
        {
          title: '周/月',
          key: 'name'
        },
        {
          title: '邀评数',
          key: 'all_count'
        },
        // {
        //   title: '实评数',
        //   key: 'user_count'
        // },
        {
          title: '好评数',
          key: 'best_count'
        },
        {
          title: '中评数',
          key: 'normal_count'
        },
        {
          title: '差评数',
          key: 'bad_count'
        },
        {
          title: '差评率',
          key: 'bad_rate'
        },
        {
          title: '目标',
          key: 'target'
        }
      ],
      loading: false
    }
  },
  beforeMount () {
  },
  methods: {
    query () {
      if (this.params.start_date === '' || this.params.end_date === '' || this.params.start_date === undefined || this.params.end_date === undefined) {
        this.$Message.error('时间必须选择')
        return
      }
      this.loading = true
      Statistics.PmpRecordEvaluate(this.params).then((res) => {
        this.result = res.data
        this.loading = false
      })
    },
    exportData () {
      let that = this
      this.$refs.table.exportCsv({
        filename: that.params.start_date + "至" + that.params.end_date + "_满意度统计"
      });
    }
  }
}
</script>

<style scoped>

</style>
